import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Sincroniza el atributo `lang` de <html> con el idioma activo de i18next.
 *
 * WCAG 3.1.1 (Language of Page) exige que el atributo lang refleje el idioma
 * real de la página. Como el sitio cambia de idioma dinámicamente sin recargar
 * en algunos casos, además del index.html estático generado por build-i18n-html
 * por idioma, este hook mantiene `document.documentElement.lang` actualizado.
 *
 * Soporta locales con región (p. ej. pt-BR) preservando la variante completa.
 */
export function useHtmlLang() {
  const { i18n } = useTranslation();

  useEffect(() => {
    const lang = i18n.resolvedLanguage || i18n.language;
    // Solo actualizar si tenemos un valor válido; nunca borrar lang del HTML.
    if (lang && typeof document !== 'undefined' && document.documentElement.lang !== lang) {
      document.documentElement.lang = lang;
    }
  }, [i18n.resolvedLanguage, i18n.language]);
}
